import React from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from "react-icons/io";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const GraphicsTable = ({ data, currentPage, itemsPerPage }) => {
  const tableHead = [
    "Sr.",
    "Post Name",
    "Post Headline",
    "Post Subheading",
    "Post Type",
    "Platforms",
    "Actions",
  ];

  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/graphics-view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return (
                <>
                  <th key={index}>{item}</th>
                </>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>

                <td>{item?.postTitle || "N/A"}</td>
                <td>{item?.postHeadline || "N/A"}</td>
                <td>{item?.postSubheading || "N/A"}</td>
                <td>{item?.postType || "N/A"}</td>
                <td>
                  <span>
                    {item?.platforms?.map((item, index) => {
                      return <span key={index}>{item}&nbsp;&nbsp;</span>;
                    })}
                  </span>
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default GraphicsTable;
